import { ErrorMessage, FieldAttributes, FieldValidator } from "formik"
import React from "react"

import Field from "../../../design-system/field"
import FormikInput from "../../../design-system/input/input-formik"
import InputError from "../../../design-system/input-error"
import Label from "../../../design-system/label"

type Props = FieldAttributes<{
  label?: string
  isValidating?: boolean
  prefix?: () => React.JSX.Element
  validate?: FieldValidator
}>
const TextField = ({
  name,
  label,
  className,
  placeholder,
  isValidating = false,
  prefix,
  validate,
}: Props) => {
  return (
    <Field className={className}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <FormikInput
        id={name}
        name={name}
        isValidating={isValidating}
        placeholder={placeholder ?? label}
        prefix={prefix}
        validate={validate}
      />
      {!isValidating && <ErrorMessage name={name} component={InputError} />}
    </Field>
  )
}

export default TextField
